import { IonContent, IonPage } from "@ionic/react";
import React, { useContext } from "react";
import { AuthenticationContext } from "../../../providers/AuthenticationProvider/AuthenticationProvider";
import UserLessonsContent from "../UserManagement/sub/UserLessonsContent";

const UserLessonLogs = () => {
  const { appUserId } = useContext(AuthenticationContext);

  return (
    <IonPage>
      <IonContent>
        <UserLessonsContent userId={appUserId} />
      </IonContent>
    </IonPage>
  );
};

export default UserLessonLogs;
